// extracted by mini-css-extract-plugin
module.exports = {"authorizeWrapper":"authorize-mod__authorizeWrapper___2oFzs","fading":"authorize-mod__fading___1XGa-"};